function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "f8acihnn4a",
  d: "M10.125 18.225 5.4 13.5l-1.575 1.575 6.3 6.3 13.5-13.5L22.05 6.3z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5 .5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "1xhml5wojb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f8acihnn4a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#1xhml5wojb)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-14.625-14.625h56.25v56.25h-56.25z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#1xhml5wojb)",
  fill: "#00857D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-52.875 22.5h56.25v56.25h-56.25z"
})));
const SvgIconLiveIcDone = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLiveIcDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-live-ic-done.5d8f9f94.svg";
export { ForwardRef as ReactComponent };